/* eslint-disable no-unused-vars */
import { useEffect, useRef } from 'react';
import { AutoSizer, CellMeasurer, CellMeasurerCache, List, WindowScroller } from 'react-virtualized';

import AlertFrame from '@/pages/notifications/components/alertframe/AlertFrame';
import InfiniteScroll from '@/shared-components/lists/components/InfiniteScroll';

import './styles/VirtualList.css';

const NOTIFICATION_ROW_GAP = 4;

const cache = new CellMeasurerCache({
  fixedWidth: true,
  minHeight: 71,
  defaultHeight: 71,
});

export default function VirtualList({ items, onLoadMore, showNewNotifications, fetch }) {
  const listRef = useRef();

  // Recalcular alturas cuando cambian los datos/estados que afectan a la altura
  useEffect(() => {
    cache.clearAll();
    if (listRef.current) {
      listRef.current.recomputeRowHeights();
      listRef.current.forceUpdateGrid?.();
    }

  }, [items?.data?.length, showNewNotifications]);

  return (
    <InfiniteScroll
      className="notifications-virtual-list remove-scrollbar"
      onLoadMore={onLoadMore}
      shouldLoadMore={items.data?.length < items.totalDocs}
      offsetElements={5}
      listLength={items.data?.length}
      defaultInfiniteLoaderClassName="notifications-virtual-list-loader"
    >
      {({ infiniteScrollAssigner, infiniteScrollParent }) => (
        <WindowScroller scrollElement={infiniteScrollParent ? infiniteScrollParent : window}>
          {({ height, isScrolling, onChildScroll, scrollTop }) => (
            <AutoSizer disableHeight>
              {({ width }) => (
                <List
                  autoHeight
                  width={width}
                  height={height}
                  isScrolling={isScrolling}
                  onScroll={onChildScroll}
                  rowCount={items.data?.length}
                  rowHeight={({ index }) => cache.rowHeight({ index }) + NOTIFICATION_ROW_GAP}
                  scrollTop={scrollTop}
                  overscanRowCount={5}
                  ref={listRef}
                  rowRenderer={({ index, key, style, parent }) => {
                    const notification = items.data[index];
                    return (
                      <CellMeasurer
                        key={key}
                        cache={cache}
                        parent={parent}
                        columnIndex={0}
                        rowIndex={index}
                      >
                        <div
                          style={style}
                          ref={infiniteScrollAssigner(index)}
                          className="notification-row"
                        >
                          <AlertFrame
                            className="notification--in-popup"
                            value={notification}
                            showNewNotifications={showNewNotifications}
                          />
                        </div>
                      </CellMeasurer>
                    );
                  }}
                />
              )}
            </AutoSizer>
          )}
        </WindowScroller>
      )}
    </InfiniteScroll>
  );
}
